<header class="header" [ngStyle]="getColor()">

    <div class="header-middle sticky-header">
        <div [ngStyle]="getMarqueeColor()" *ngIf="marqueeText?.length >0 ">
            <ngx-fast-marquee class="--floating-center --rotate" speed="medium" [maskPercentage]="0" direction="left" [pauseOnHover]="true" [play]="true">
                <div class="item --bold --box span-class" role="marquee"  style="margin-top: 8px;font-size: 9.75pt; font-weight:700.00;" *ngFor="let text of marqueeText">
                  {{text.title}}
                </div>
              </ngx-fast-marquee>
        </div>
        <div class="container-fluid" style='background:#000;' [ngStyle]="getColor()">
            <div class="laptop-menu-bar">
                <div class="row" style="width: 100%;">
                    <div class="col-md-4" style="margin: auto;">
                        <a href="/" (click)="logoFunction()" class="logo logo-top-space">
                            <img src="{{siteDada?.footerLogo?.url}}" alt="" class="laptop-logo-size" width="100" height="100">
                        </a>
                        <div class="hearder-store-infi">
                            <!-- <h3>{{selectedStoreName}} </h3> -->
                            <h4 *ngIf="this.storeTime && !StoreClosed" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})">
                                Open Until
                                {{newStoreHoursFormat(this.storeTime?.Close?.Hour,this.storeTime?.Close?.Minute)}}
                                <a href="javascript:;" (click)="modalOpen()">
                                    <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                                </a>
                            </h4>
                            <h4 *ngIf="this.storeTime && StoreClosed " style="color: red;">Closed
                                <a href="javascript:;" style="position: relative;top: 1px;"  (click)="modalOpen()">
                                    <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                                </a>
                            </h4>
                            <h4 *ngIf="!this.storeTime && !StoreClosed">
                                <a href="javascript:;" (click)="modalOpen()">
                                    <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                                </a>
                            </h4>
                        </div>
                    </div>
                    <div class="col-md-4" style="margin: auto;">
                        <div class="header-new-search-bar">
                            <form action="">
                                <input type="text" placeholder="Smart Search" #dynamicPlaceholder [ngStyle]="getTextIconColor({'border':'2px solid' +siteDada?.headerTextColor})" name="search" id="searchInfor" [(ngModel)]="searchInput" (keyup)="searchSuggest($event)" (keyup.enter)="searchProduct(searchInput)" autocomplete="off">
                                <i class="icon-search" (click)="searchProduct(searchInput)" [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor})"></i>
                                <div id="DivOut" *ngIf="searchIn || suggList" style="position: absolute;background: white;width: 100%;z-index: 9; height: auto; overflow-y: scroll;">
                                    <span style="font-size: 12px; margin:5px;">Discover More</span>
                                    <ul style="list-style: none;">
                                        <li class="searchinheader" *ngFor="let item of topSearchArray" style="display: flex;align-items: center; color: #000 !important;">
                                            <a class="text_mobile_search" (click)="searchProduct(item?.slug)" style="padding: 5px 10px; font-size: 14px; width: 100%;">{{item?.name}}</a>
                                        </li>
                                    </ul>
                                    <ul style="list-style: none;">
                                        <li class="searchinheader" *ngFor="let pl of search_suggestionArr" style="display: flex;align-items: center;">
                                            <img class="img_mobile_search" style="margin: 0px 10px;width: 30px;height: 30px;" [src]="pl.productDetails.Assets?.length?pl?.productDetails.HeroShotUri:defaultUrl">
                                            <a class="text_mobile_search" style="color: #000;" routerLink="/product-details/{{pl?.productslug}}" (click)="hideSearchDiv()" style="margin: 10px 0px; font-size: 14px; color: #000 !important">{{pl?.productDetails?.ProductName}}</a>
                                        </li>
                                    </ul>
                                </div>

                                <div style="position: absolute;background: white;width: 100%;
                                z-index: 9;">
                                    <p *ngIf="!searchIn && showNoResult" style="padding:10px;">No Results</p>
                                </div>
                            </form>
                        </div>


                    </div>
                    <div class="col-md-4" style="margin: auto;">
                        <div class="header-right right-herader-top">
                            <div class="header-search laptop-search-bar-newone" style="position: inherit;display: none;">
                                <a href="javascript:;" (click)="isSearchShow= !isSearchShow" class="search-toggle" role="button" title="Search"><i class="icon-search" autocomplete="off" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i></a>
                                <form [ngClass]="{desktopSearch: !isSearchShow}">
                                    <div class="header-search-wrapper" id="search1">
                                        <a href="javascript:;" (click)="isSearchShow= !isSearchShow" role="button" title="Close" class="laptop-close-newone">
                                            <i class="icon-close"></i>
                                        </a>
                                        <label for="search" class="sr-only">Search</label>
                                        <input type="text" class="form-control" name="search" placeholder="Smart Search" (click)="$event.stopPropagation()" [(ngModel)]="searchInput" (keyup)="searchSuggest($event)" (keyup.enter)="searchProduct(searchInput)">
                                        <div id="DivOut" *ngIf="searchIn" style="position: absolute;background: white;width: 100%;z-index: 9;">
                                            <span style="font-size: 12px; margin:5px;">Discover More</span>
                                            <ul style="list-style: none;">
                                                <li class="searchinheader" *ngFor="let pl of search_suggestionArr" style="display: flex;align-items: center;">
                                                    <img class="img_mobile_search" style="margin: 0px 10px;width: 30px;height: 30px;" [src]="pl.productDetails.Assets?.length?pl.productDetails.Assets[0]['Uri']:defaultUrl">
                                                    <a class="text_mobile_search" routerLink="/product-details/{{pl.productslug}}" (click)="hideSearchDiv()" style="margin: 10px 0px; font-size: 14px;">{{pl.productDetails.ProductName}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div style="position: absolute;background: white;width: 100%;
                                                        z-index: 9;">
                                            <p *ngIf="!searchIn && showNoResult" style="padding:10px;">No Results</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="dropdown cart-dropdown">
                                <a href="javascript:;" class="dropdown-toggle cursor" *ngIf="!auth" (click)="openLogin()" style="margin-right: 8px;">
                                    <i class="icon-user" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                                </a>


                                <a href="javascript:;" (click)="openShoppingCart()" class="cursor dropdown-toggle">
                                    <i class="icon-shopping-cart" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                                    <span class="cart-count" style="position: absolute; top: -10px; right: -9px;">{{cartLength}}</span>
                                </a>
                            </div>
                            <div style='margin-left:15px;'>
                                <a href="javascript:;" onclick="openNav()" class="menu-bar menu-icon-size cursor">
                                    <!-- <img src="assets/images/menu-icon.png" style="width: 22px;"> -->
                                    <i class="fa fa-bars" aria-hidden="true" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                                </a>
                            </div>
                        </div>
                        <div class="header-left" style="float: right;top: 16px; position: relative;display: none;">
                            <nav class="main-nav">
                                <ul class="menu sf-arrows">
                                    <li><a [routerLink]="" routerLinkActive="router-link-active">Shop <i class="fa fa-angle-down"></i></a>
                                        <ul>
                                            <li *ngFor="let list of displayCategoryList">
                                                <a href="javascript:void(0)" (click)="redirectToShopPage(list)" [class.activeCategory]="categoryName===list.Name">
                                                    {{list.Name.split(' ')[0]}}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div *ngIf="auth" class="right-head-username">
                            <span style="font-size: 16px;"> <a routerLink="/dashboard/profile" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})">Hi, &nbsp; {{userName | firstword |
                                    titlecase}}</a> </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile-menu-bar">
                <div class="header-left">
                    <a href="/" class="logo">
                        <img src="{{siteDada?.footerLogo?.url}}" alt="" width="80" height="80">
                    </a>
                    <div class="hearder-store-infi">
                        <!-- <h3>{{selectedStoreName}}</h3> -->
                        <h4 *ngIf="this.storeTime && !StoreClosed " [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})">
                            Open Until
                            {{newStoreHoursFormat(this.storeTime?.Close?.Hour,this.storeTime?.Close?.Minute)}}
                            <a href="javascript:;" (click)="modalOpen()">
                                <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                            </a>
                        </h4>
                        <h4 *ngIf="this.storeTime && StoreClosed " style="color: red;">Closed
                            <a href="javascript:;" style="position: relative;top: 1px;"  (click)="modalOpen()">
                                <i class="fa fa-info-circle"></i>
                            </a>
                        </h4>
                        <h4 *ngIf="!this.storeTime && !StoreClosed">
                            <a href="javascript:;" (click)="modalOpen()">
                                <i class="fa fa-info-circle"></i>
                            </a>
                        </h4>
                    </div>
                </div>
                <div class="header-right">
                    <div class="header-search" [ngClass]="{mobileSearch: isSearchShow}">
                        <a href="javascript:;" (click)="isSearchShow= !isSearchShow" class="search-toggle" role="button" title="Close"><i class="icon-close"></i></a>
                        <a href="javascript:;" class="mobile-search-button"><i class="icon-search" (click)="searchProduct(searchInput)"></i></a>
                        <form>
                            <div class="" id="search1">
                                <label for="search" class="sr-only">Search</label>
                                <input type="text" class="form-control" name="search" id="search" placeholder="Smart Search" (click)="$event.stopPropagation()" [(ngModel)]="searchInput" (keyup)="searchSuggest($event)" (keyup.enter)="searchProduct(searchInput)" appAutocompleteOff>
                                <div id="DivOut" *ngIf="searchIn" style="position: absolute;background: white;width: 100%;z-index: 9;">
                                    <span style="font-size: 12px; margin:5px;">Discover More</span>
                                    <ul style="list-style: none;">
                                        <li class="searchinheader" *ngFor="let pl of search_suggestionArr" style="display: flex;align-items: center;">
                                            <img style="margin: 0px 10px; width: 25px; height: 25px" [src]="pl.productDetails.Assets?.length ? pl.productDetails.Assets[0]['Uri'] : defaultUrl" />
                                            <a class="text_mobile_search" routerLink="/product-details/{{pl.productslug}}" (click)="hideSearchDiv()" style="margin: 10px 0px; font-size: 14px;color: #000 !important">{{pl.productDetails.ProductName}}</a>
                                        </li>
                                    </ul>
                                </div>
                                <ng-container *ngIf="suggList">
                                    <div id="DivOut" style="position: absolute;background: white;width: 100%;z-index: 9; height: 400px; overflow-y: scroll;">
                                        <span style="font-size: 12px; margin:5px;">Suggestion</span>
                                        <ul style="list-style: none;">
                                            <li class="searchinheader" *ngFor="let item of topSearchArray" style="display: flex;align-items: center;">
                                                <a class="text_mobile_search" (click)="searchProduct(item.slug)" style="padding: 8px 10px; font-size: 14px; width: 100%;color: #000 !important">{{item.name}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </ng-container>
                                <div style="position: absolute;background: white;width: 100%;
                                            z-index: 9;">
                                    <p *ngIf="!searchIn && showNoResult" style="padding:10px;">No Results</p>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="dropdown cart-dropdown">
                        <a href="javascript:;" class="search_head" (click)="isSearchShow= !isSearchShow">
                            <i class="icon-search" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                        </a>

                        <a href="javascript:;" (click)="openLogoutPopUp()" *ngIf="auth" class='dropdown-toggle' style="font-size: 2.7rem;margin-right: 2px;">
                            <i class="fa fa-sign-out" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                        </a>

                        <a *ngIf="!auth" (click)="openLogin()" class="dropdown-toggle cursor" style="margin-right: 2px;">
                            <i class="icon-user" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                        </a>
                        <a href="javascript:;" (click)="openShoppingCart()" class="dropdown-toggle cursor">
                            <i class="icon-shopping-cart" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                            <span class="cart-count">{{cartLength}}</span>
                        </a>
                    </div>
                </div>
                <div class="responsive-meni-bar-toggle">
                    <a onclick="openNav()" class="menu-bar">
                        <!-- <img src="assets/images/menu-icon.png" class="mobile_menu_bar"> -->
                        <i class="fa fa-bars" aria-hidden="true" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor})"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="header-menu-section " [ngStyle]="getColor()">
            <div class="container">
                <div class="row for-desktop-menu">
                    <div class="col-md-12">
                        <nav class="new-menu-part">
                            <ul class="menu sf-arrows">
                                <ng-container *ngIf="categoryList">
                                    <li><a *ngIf="categoryList?.length" href="javascript:void(0)" routerLink="/shop/all" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600})"> ALL PRODUCTS</a></li>

                                    <li><a *ngIf="categoryList?.length" href="javascript:void(0)" routerLink="/shop/deals" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600})"> DEALS</a></li>
                                    <li *ngFor="let list of categoryList; let i = index;">
                                        <a [class.activeCategory]="list?.slug == CategoryId" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600})" href="javascript:void(0)" (click)="redirectToShopPage(list)">
                                            {{list?.categoryName | uppercase }} <i *ngIf="list?.subCategory?.length" class="fa fa-angle-down"></i>
                                        </a>
                                        <ul>
                                            <li *ngFor="let subCategory of list?.subCategory">
                                                <a href="javascript:void(0)" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600},'subcat')" (click)="redirectToShopPageWithSubCategoryId(subCategory,list)">
                                                    {{subCategory?.subCategoryName | uppercase }}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ng-container>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div class="for-mobile-menu">
                    <ul class="">
                        <ng-container *ngIf="categoryList">
                            <li><a *ngIf="categoryList?.length" href="javascript:void(0)" routerLink="/shop/all" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600})">ALL PRODUCTS</a></li>

                            <li><a *ngIf="categoryList?.length" href="javascript:void(0)" routerLink="/shop/deals" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600})"> DEALS</a></li>

                            <li *ngFor="let item of categoryList; let i = index;">
                                <a href="javascript:void(0)" (click)="openSubCat(item)" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600})">
                                    {{item?.categoryName | uppercase}}
                                </a>
                            </li>
                            <ng-container *ngIf="subCatList?.length > 0 && subCatClick == true">
                                <ul class="mobile_sub_menu_list">
                                    <li (click)="redirectToShopPage(subCategoryMobile);subCatClick = false">
                                        <a href="javascript:void(0)" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor ,'font-weight': 600},'subcatMobile')">All {{subCategoryMobile?.categoryName | uppercase }}</a>
                                    </li>
                                    <li *ngFor="let subCategory of subCatList">

                                        <a href="javascript:void(0)" [ngStyle]="getTextIconColor({'color':this.siteDada?.headerTextColor,'font-weight': 600},'subcatMobile')" (click)="redirectToShopPageWithSubCategoryId(subCategory,subCategoryMobile)">
                                            {{subCategory?.subCategoryName | uppercase }}
                                        </a>
                                    </li>
                                </ul>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</header>
<app-sidenav></app-sidenav>
<app-register></app-register>



<div class="hedaerHeightLaptop"></div>